export enum TeamCategoryId {
  DAMA = 2,
  FAMILIA = 3,
  MENOR = 1,
  TRIO_DE_DAMAS = 4,
}

export const TeamCategoryTranslations = {
  [TeamCategoryId.DAMA]: "Dama",
  [TeamCategoryId.FAMILIA]: "Familia",
  [TeamCategoryId.MENOR]: "Menor",
  [TeamCategoryId.TRIO_DE_DAMAS]: "Trio de Damas",
};

export interface TeamCategory {
  id: number;
  team_id: number;
  category_id: number;
  created_at: Date;
  updated_at: Date;
}

export interface TeamCategorySimple {
  category_id: number;
  team_id: number;
}
